<template>
  <div class="ma-2" v-if="tiene_permiso">
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">Listado de dosificaciones</h3>
        <v-spacer></v-spacer>
        <!-- <download-excel v-if="dosificaciones.length" :fields="json_fields" name="dosificaciones.xls" :data="dosificaciones">
          <v-btn type="button" rounded color="success" dark class="mb-2 mx-2"> <v-icon class="mr-1">mdi-microsoft-excel</v-icon> Exportar </v-btn>
        </download-excel> -->

        <!-- fomulario crear o editar -->
        <create-update-form :sucursales="sucursales" ref="refForm" :editedIndex.sync="editedIndex"></create-update-form>
      </v-card-title>
      <v-card-text class="mt-2">
        <v-data-table :items-per-page="-1" :search="search" :headers="headers" :items="dosificaciones" class="elevation-1" :item-class="itemRowBackground">
          <template v-slot:top>
            <v-toolbar flat>
              <v-text-field autofocus outlined dense v-model="search" append-icon="mdi-magnify" label="Buscar" hide-details />
            </v-toolbar>
          </template>
          <template #[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="success" class="ma-1" @click="detailItem(item)"> mdi-eye </v-icon>
              </template>
              Ver Detalle
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="info" class="ma-1" @click="editItem(item)"> mdi-book-edit </v-icon>
              </template>
              Editar
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <show-detail ref="refDetails" @showedit="editItem"></show-detail>
  </div>
  <div class="pa-3" v-else>
    <p class="red--text text-center">
      <v-icon color="red">mdi-block-helper</v-icon>
      <br />
      Usuario no autorizado para este visualizar este contenido
    </p>
  </div>
</template>

<script>
import CreateUpdateForm from './CreateUpdateForm';
import ShowDetail from './ShowDetail';

export default {
  components: {
    CreateUpdateForm,
    ShowDetail,
  },
  data() {
    return {
      search: '',
      tiene_permiso: true,
      editedIndex: -1,
      headers: [
        { text: 'ID', value: 'sucursal_id' },
        { text: 'sucursal', value: 'sucursal.ciudad' },
        { text: 'factura', value: 'num_factura' },
        { text: 'Autorizacion.', value: 'autorizacion' },
        { text: 'Codigo Dosificacion.', value: 'codigo_dosificacion' },
        { text: 'fecha_limite', value: 'fecha_limite' },
        { text: 'nit', value: 'nit' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      sucursales: [
        { id: 1, nit_id: 2, direccion: 'lejos', linea1: 'linea1', linea2: 'linea2', ciudad: 'tarija', numero_sucursal: 3, sede_id: 1 },
        { id: 2, nit_id: 1, direccion: 'lejos', linea1: 'linea1', linea2: 'linea2', ciudad: 'tarija Sucursal', numero_sucursal: 2, sede_id: 2 },
        { id: 3, nit_id: 1, direccion: 'lejos', linea1: 'linea1', linea2: 'linea2', ciudad: 'Sucre', numero_sucursal: 1, sede_id: 3 },
      ],
      dosificaciones: [
        {
          sucursal_id: 2,
          sucursal: {
            ciudad: 'La paz',
          },
          num_factura: '1321d5616',
          autorizacion: '1d3215616',
          codigo_dosificacion: '13f215616',
          fecha_limite: '2020-12-12',
          nit: '123465789',
          actividad: 'texto largo',
        },
        {
          sucursal_id: 1,
          sucursal: {
            ciudad: 'Santa cruz',
          },
          num_factura: '13215616',
          autorizacion: '13215616',
          codigo_dosificacion: '13215616',
          fecha_limite: '2020-12-12',
          nit: '123465789',
          actividad: 'texto largo',
        },
        {
          sucursal_id: 3,
          sucursal: {
            ciudad: 'Sucre',
          },
          num_factura: '13215616',
          autorizacion: '13215616',
          codigo_dosificacion: '13215616',
          fecha_limite: '2020-12-12',
          nit: '123465789',
          actividad: 'texto largo',
        },
      ],
      json_fields: {
        sucursal: 'sucursal.ciudad',
        num_factura: 'num_factura',
        autorizacion: 'autorizacion',
        codigo_dosificacion: 'codigo_dosificacion',
        fecha_limite: 'fecha_limite',
        nit: 'nit',
        actividad: 'actividad',
      },
    };
  },
  methods: {
    detailItem(item) {
      this.$refs.refDetails.showDialog(item);
    },
    editItem(item) {
      this.editedIndex = this.dosificaciones.indexOf(item);
      this.$refs.refForm.showDialog(item);
    },

    itemRowBackground(item) {
      return item.estado ? '' : 'deshabilitado';
    },
  },
};
</script>
<style>
.deshabilitado {
  background-color: #ff050033;
}
</style>
